module.exports = __webpack_public_path__ + "static/img/preview-gray-no-progress-bar.a0f0ebeb.png";